import { render, staticRenderFns } from "./ner.vue?vue&type=template&id=5230a56a&scoped=true&"
import script from "./ner.vue?vue&type=script&lang=js&"
export * from "./ner.vue?vue&type=script&lang=js&"
import style0 from "./ner.vue?vue&type=style&index=0&id=5230a56a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5230a56a",
  null
  
)

export default component.exports